// extracted by mini-css-extract-plugin
export default {"root":"P0dCOY","bg":"PJ4KCX"};